module.exports = __webpack_public_path__ + "img/article-image-3.885980e2.webp";